<template>
	<button
		:class="`icon-button ${size}`"
		@click="handleClick"
		:aria-label="ariaLabel"
	>
		<font-awesome-icon :icon="[`${iconStyle}`, `${iconName}`]" />
	</button>
</template>

<script>
export default {
	name: 'IconButton',
	props: {
		iconStyle: String,
		iconName: String,
		size: {
			default: 'small',
			type: String,
			validator: (prop) => ['small', 'large'].includes(prop),
		},
		ariaLabel: {
			type: String,
			default: 'Icon Button',
		},
	},
	methods: {
		handleClick() {
			this.$emit('onClick');
		},
	},
};
</script>

<style lang="scss" scoped>
.icon-button {
	border: 1px solid $border-color-light;
	border-radius: 6px;
	color: $brand-blue;
	background-color: $white;
	transition: all 0.3s ease;
	@include rem('font-size', 15px);
	@include rem('padding', 8px);

	&.small {
		width: 34px;
		height: 34px;
	}

	&.large {
		width: 44px;
		height: 44px;
	}

	&:hover,
	&:focus,
	&:active,
	&.active {
		background-color: $highlight-color;
		border: 1px solid $brand-blue;
		cursor: pointer;
		outline: none;
	}
}
</style>
